module.exports = __webpack_public_path__ + "static/media/pos-facil-computer.416b9a02.png";